import { Navigate } from 'react-router-dom';
import { useAdmin } from '@/contexts/AdminContext';

const ProtectedRoute = ({ children, requireSuperAdmin = false, requiredPermission = null }) => {
  const { admin, loading, hasPermission } = useAdmin();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-900">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600"></div>
      </div>
    );
  }

  if (!admin) {
    return <Navigate to="/admin/login" replace />;
  }

  if (requireSuperAdmin && admin.role !== 'super_admin') {
    return <Navigate to="/admin/dashboard" replace />;
  }

  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
